import i18next from "i18next";

export const SliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  swipeToSlide: false,
  swipe: false,
  touchMove: false,
  pauseOnFocus: true,
  pauseOnHover: true,
  draggable: false,
  autoplay: false,
  accessibility: false,
  arrows: false,
  lazyLoad: "progressive",
};

export const CommuterTicketValueRegExp = "^[0-9]{10}$";

export const SingleTicketValueRegExp = "^([a-zA-ZåäöÅÄÖ]{3}[0-9]{4}[a-zA-ZåäöÅÄÖ]{1})$|^([a-zA-ZåäöÅÄÖ]{3}[0-9]{4}[a-zA-ZåäöÅÄÖ]{1}[0-9]{4})$|^([0-9a-zA-ZåäöÅÄÖ]{6})$";

export const NationalReserveIdentityRegExp = "^([0-9]{8})-?(((?![IOQVW])[A-Z]){2}[0-9]{2}|((?![IOQVW])[A-Z]){3}[0-9]{1})$";

export const EmailRegExp = "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$";

export const SSNRegExp = "^\\d{4}-\\d{2}-\\d{2} \\d{4}$";

export const DepartureTimeExp = "^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$";

export const PhoneNumberRegExp = "^[+]?[\\d]+[ -\\d]*[\\d]$";

export const ValidTextRegExp = "^[^;%<>\\$'\"]*$";

export const ValidTicketNumberRegExp = "^[^;%<>\\'\"]*$";

export const ValidUsernameRegExp = "^[^;%<>\\$'\"\\s]*$";

export const ValidPasswordRegExp = "^[a-zA-Z0-9!@#$%^&*]*$";

export const ValidPostalRegExp = "^[0-9]{5}$|^[0-9]{3}\\s[0-9]{2}$";

export const RegistrationNumberRegExp = "^([a-zA-ZåäöÅÄÖ]{3}[ ]?[0-9]{3})$|^([a-zA-ZåäöÅÄÖ]{3}[ ]?[0-9]{2}[a-zA-ZåäöÅÄÖ]{1})$";

// export const SingleTicketFormatRegExp = "^([a-zA-ZåäöÅÄÖ]{3}[0-9]{4}[a-zA-ZåäöÅÄÖ]{1}[0-9]{4})$";

export const SingleTicketFormatRegExp = "^[0-9a-zA-ZåäöÅÄÖ]{8,14}$";

export const MovingoTicketRules = {
  MinLength: 8,
};

export const Options = [
  { key: "Pendlarbiljett", value: "Pendlarbiljett" },
  { key: "Enkelbiljett", value: "Enkelbiljett" },
];

export const TransportationType = {
  USEOWNCAR: "OWN_CAR",
  TAXI: "TAXI",
  OTHERS: "OTHERS",
};

export const ReceiptType = {
  Food: "Food",
  Transportation: "Transportation",
  Extra: "Extra",
};

export const TicketType = {
  SINGLE: "Single",
  COMMUTER: "Period",
};

export const Reports = {
  Fraud: "Fraud",
  Accounting: "Accounting",
};

export const MinDate = 61;

export const MaxReceipt = 1;

export const MaxFoodReceipt = 3;

export const MaxNumberOfAttachments = 3;

export const MaxFileSize = 26214400; //25MB


export const lngs = {
  en: { nativeName: "English", code: "en" },
  sv: { nativeName: "Svenska", code: "sv" },
};

export const DataType = {
  String: 0,
  Bool: 1,
  Int: 2,
  Array: 3,
  Decimal: 4,
};

export const AutomaticApprovalSettings = {
  Enable: "Enable",
  ValidDays: "ValidDays",
  LongShortTripKmThreshold: "LongShortTripKmThreshold",
  DelayMin: "DelayMin",
  LinesToRemove: "LinesToRemove",
  Periods: "Periods",
  StopsToRemove: "StopsToRemove",
  TotalCostSEKMax: "TotalCostSEKMax",
  TransportationCostSEKMax: "TransportationCostSEKMax",
  CompensationForOwnCar: "CompensationForOwnCar",
  MaxClaimsIn24Hours: "MaxClaimsIn24Hours",
  MaxClaimsDuring7Days: "MaxClaimsDuring7Days",
  MaxClaimsDuring30Days: "MaxClaimsDuring30Days",
  MaxOpenClaims: "MaxOpenClaims",
  MaxMoneyToApprove: "MaxMoneyToApprove",
  MaxMoneyToApproveDuring30Days: "MaxMoneyToApproveDuring30Days",
  LongShortTripValidDaysMax: 90,
  BasePriceFor30dayTicket: "BasePriceFor30dayTicket",
  BasePriceFor90dayTicket: "BasePriceFor90dayTicket",
  BasePriceFor360dayTicket: "BasePriceFor360dayTicket",
  SingleTicketAutomaticProcessingIsEnabled: "SingleTicketAutomaticProcessingIsEnabled",
  CommuterTicketAutomaticProcessingIsEnabled: "CommuterTicketAutomaticProcessingIsEnabled",
  AutomaticApprovalIsEnabled: "AutomaticApprovalIsEnabled",
  AutomaticRejectionIsEnabled: "AutomaticRejectionIsEnabled",
  AllowedFileExtension: "AllowedFileExtension",
  HoursUntilClaimsBeingProcessed: "HoursUntilClaimsBeingProcessed",
  MonthToDeleteSensitiveData: "MonthToDeleteSensitiveData",
};

export const FraudReportColumns = [
  { id: "PersonalID", label: i18next.t("personal_ID"), minWidth: 170 },
  { id: "FirstName", label: i18next.t("firstname"), minWidth: 170 },
  { id: "LastName", label: i18next.t("surname"), minWidth: 170 },
  { id: "ReimbursementSEK", label: i18next.t("reimbursement_SEK"), minWidth: 170 },
  { id: "TicketPriceSEK", label: i18next.t("ticket_price_SEK"), minWidth: 170 },
  { id: "ClaimWithoutTicketNumber", label: i18next.t("number_of_claims_without_ticket"), minWidth: 170 },
  { id: "CaseNumbers", label: i18next.t("case_number"), minWidth: 170 },
];

export const AllowedFileExtensions = [
  { key: "JPEG", value: "JPEG" },
  { key: "JPG", value: "JPG" },
  { key: "BMP", value: "BMP" },
  { key: "GIF", value: "GIF" },
  { key: "PNG", value: "PNG" },
  { key: "PSD", value: "PSD" },
  { key: "TIFF", value: "TIFF" },
  { key: "TIF", value: "TIF" },
  { key: "PDF", value: "PDF" },
  { key: "DOC", value: "DOC" },
  { key: "DOCX", value: "DOCX" },
];

export const UserRoles = {
  SuperAdmin: "SuperAdmin",
  SystemAdmin: "SystemAdmin",
  CaseManager: "CaseManager",
};

export const ApiOperationStatus = {
  Success: 0,
  UnAuthorized: 1,
  Exception: 2,
};

export const MaximumIdleTimeInMinute = 10;

export const MaximumLengthOfOtherTicketValue = 30;

export const TopDeskErrorResponse = 512;

export const UserNotFoundInEvfSystemError = "user_not_found_in_evf_system";

export const UserNotLogInError = "user_not_login";

export const PostalCodeLength = 6;

export const TransportationMethod = {
  BUS: "BUS",
  TRAIN: "TRAIN",
};
